import React, { PureComponent } from 'react';

import PaymentDetails from './PaymentDetails';
import PaymentFilters from './PaymentFilters';
import Auth from '../../../libs/Auth';
import CreatePayment from './CreatePayment';
import AmazonCrossCheck from './AmazonCrossCheck';

class PaymentsView extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      expanded: {}
    }
  }
  toggle(id){
    const { expanded } = this.state;
    this.setState({
      expanded: {
        ...expanded,
        [id]: !expanded[id]
      }
    });
  }
  render() {
    let {
      payments,
      filtersFormState,
      page,
      nextPage,
      previousPage,
      exportCSV,
      openCreateModal,
      openCrossCheckModal,
      amazonAccounts,
    } = this.props;

    const exportDisabled = filtersFormState.data.status !== 'verified' || !filtersFormState.data.type;

    return (
      <div className="admin-payments-view">
        <PaymentFilters {...this.props}/>
        <div className="export-csv-container">
          <button className="button" type="button" onClick={openCrossCheckModal}>?</button>
          <button className="button" type="button" onClick={openCreateModal}>+</button>
          {Auth.isType(['admin']) && (
            <button onClick={() => exportCSV('Raise.com')} className={`button ${exportDisabled ? 'disabled' : ''}`} type="button" disabled={exportDisabled}>Raise.com Export</button>
          )}
          {Auth.isType(['admin']) && (
            <button onClick={() => exportCSV('Cardpool')} className={`button ${exportDisabled ? 'disabled' : ''}`} type="button" disabled={exportDisabled}>Cardpool Export</button>
          )}
        </div>
        <table>
          <thead>
          <tr>
            <th>TradeId</th>
            <th>Trade Status</th>
            <th>Date</th>
            <th>Code</th>
            <th>Pin</th>
            <th>Status</th>
            <th>Type</th>
            <th>Currency</th>
            <th>Value</th>
            <th>Remaining</th>
            <th>Account</th>
            <th>Order #</th>
            <th></th>
          </tr>
          </thead>

          {payments.map((payment, i)=>(
            <PaymentDetails
              isEven={i%2}
              key={payment._id}
              expanded={this.state.expanded[payment._id]}
              toggle={()=>this.toggle(payment._id)}
              filtersFormState={filtersFormState}
              page={page}
              payment={payment}
            />
          ))}
          <tbody>
          <tr>
            <td colSpan="13">
              <ul className="pagination">
                <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                  {page > 1  ? (
                    <a onClick={e=>{
                      e.preventDefault();
                      previousPage();
                    }}>Previous</a>
                  ) : 'Previous'}

                </li>
                <li>{page}</li>
                <li className="pagination-next">
                  <a onClick={e=>{
                    e.preventDefault();
                    nextPage();
                  }}>Next</a>
                </li>
              </ul>
            </td>
          </tr>

          </tbody>
        </table>

        <CreatePayment />
        <AmazonCrossCheck />

      </div>
    );
  }
}

export default PaymentsView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/Payments.view.js